import { createSlice } from '@reduxjs/toolkit';

const modalInitialState = {
  modalVisibility: false,
  modalType: '',
  modalProps: {},
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState: modalInitialState,
  reducers: {
    showModal: (state, action) => {
      state.modalVisibility = true;
      state.modalType = action.payload.modalType;
      state.modalProps = action.payload.modalProps;
    },
    hideModal: (state) => {
      state.modalVisibility = modalInitialState.modalVisibility;
      state.modalType = modalInitialState.modalType;
      state.modalProps = modalInitialState.modalProps;
    },
  },
});

export const { showModal, hideModal } = modalSlice.actions;

export default modalSlice.reducer;
